export const ERROR_CODES: number[] = [400, 404, 500];

export const GENERAL_ERROR_MESSAGE = 'Beklenmeyen bir hata oluştu';
